//@flow

import React from 'react';

import { Customer } from '../domain/customer';

type Props = {
  customer: Customer,
  talking: boolean,
  onRequestToTalk: Customer => void,
};

class PizzaCustomerIcon extends React.PureComponent<Props> {
  render() {
    const { customer, talking } = this.props;
    const customerClassName = `${customer.type}${customer.subtype} ${talking ? 'talking' : ''}`;
    return (
      <div className={'pizza-customer-icon-container'}>
        <div className={`pizza-talk-bubble ${talking ? '' : 'hidden'}`}>
          <div className="proc-small-font gray100-color pizza-talk-bubble-content">{this.props.customer.talk()}</div>
        </div>
        <div
          className={`proc-hover pizza-icon pizza-customer-icon primary100-border-color ${customerClassName}`}
          onClick={() => this.props.onRequestToTalk(this.props.customer)}
        />
      </div>
    );
  }
}

export default PizzaCustomerIcon;
